export const useScrollToCenter = () => {
  const scrollToCenter = (target: HTMLElement, container: HTMLElement) => {
    // 计算目标元素中心点与容器中心点的偏移量
    const targetCenter = target.offsetLeft + target.offsetWidth / 2;
    const containerCenter = container.offsetWidth / 2;
    const scrollPosition = targetCenter - containerCenter;

    // 平滑滚动到计算位置
    container.scrollTo({
      left: scrollPosition,
      behavior: "smooth",
    });
  };

  return { scrollToCenter };
};
